import * as React from 'react';
import { styled, alpha } from '@mui/material/styles';
import Menu, { MenuProps } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { PopoverOrigin } from '@mui/material';
import { ActionMenuItem } from '../../models/interfaces';

const StyledMenu = styled((props: MenuProps) => (
  <Menu elevation={0} {...props} />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
  },
}));

interface IProps {
  idButton: string;
  idMenu: string;
  anchorEl: null | HTMLElement;
  setAnchorEl: (value: null | HTMLElement) => void;
  menuItems: ActionMenuItem[];
  anchorOrigin?: PopoverOrigin | null;
  transformOrigin?: PopoverOrigin | null;
}

export default function CustomizeMenu(props: IProps) {
  const {
    idButton,
    idMenu,
    anchorEl,
    setAnchorEl,
    menuItems,
    anchorOrigin,
    transformOrigin,
  } = props;
  const open = Boolean(anchorEl);
  const defaultAnchorOrigin: PopoverOrigin = {
    vertical: 'bottom',
    horizontal: 'left',
  };
  const defaultTransformOrigin: PopoverOrigin = {
    vertical: 'top',
    horizontal: 'left',
  };
  const handleClickMenuItem = (callback?: () => void | null) => {
    setAnchorEl(null);
    callback && callback();
  };

  return (
    <StyledMenu
      id={idMenu}
      MenuListProps={{
        'aria-labelledby': idButton,
      }}
      anchorOrigin={anchorOrigin ? anchorOrigin : defaultAnchorOrigin}
      transformOrigin={
        transformOrigin ? transformOrigin : defaultTransformOrigin
      }
      anchorEl={anchorEl}
      open={open}
      onClose={() => setAnchorEl(null)}
    >
      {menuItems.map((item, index) => (
        <MenuItem
          onClick={() => handleClickMenuItem(item?.callback)}
          disableRipple
          disabled={item?.disabled}
          key={index}
        >
          {item?.icon}
          {item?.text}
        </MenuItem>
      ))}
    </StyledMenu>
  );
}
